import React from 'react'
import { InlineEditPopover } from './InlineEditPopover'

interface InheritableBidFieldProps {
    bid: number | null | undefined
    adGroupDefaultBid: number | null | undefined
    disabled?: boolean
    onSave: (cents: number | null) => Promise<unknown>
    allowClear?: boolean
}
export const InheritableBidField = ({
    bid,
    adGroupDefaultBid,
    disabled = false,
    onSave,
    allowClear = false,
}: InheritableBidFieldProps) => {
    return (
        <InlineEditPopover
            value={bid}
            fallback={adGroupDefaultBid}
            label="Bid"
            onSave={onSave}
            disabled={disabled}
            inherited={bid == null && adGroupDefaultBid != null}
            allowClear={allowClear}
        />
    )
}
